import React, { useState } from "react";

import { captureErrorMessage, parseError } from "@/lib/helpers/captureErrorMessage";
import { patientRequests } from "@/api/(requests)/patient";
import { showToast } from "@/providers/ToastProvider";

import PatientProfileEmergencyInfo from "./PatientProfileEmergencyInfo";
import ProfileBasicInfo from "./ProfileBasicInfo";

import "./Profile.styles.scss";

export const SEC = "SEC";
export const PRI = "PRI";

export function Profile({ profileData: initialProfileData, reloadImg }) {
  const [profileData, setProfileData] = useState(initialProfileData);

  const submitHandler = (formData, actions) => {
    const data = structuredClone(formData);

    data["90_day_care_plan"] = data.ninety_day_care;
    if (data.avatar === "") {
      delete data.avatar;
    }

    patientRequests
      .update_profile({ data })
      .then(() => {
        actions.setSubmitting(false);
        setProfileData(data);
        reloadImg(data);
      })
      .catch((error) => {
        actions.setSubmitting(false);
        captureErrorMessage(parseError({ error, fallback: "Failed to update patient profile" }), {
          tags: { component: "Profile", errorType: "submit_profile" },
        });
        showToast([{ heading: "Failed to update profile.", variant: "error" }]);
      });
  };

  return (
    <div className="PatientProfile">
      <div className="row no-gutters tw:justify-center">
        <div className="col-12">
          {profileData && (
            <ProfileBasicInfo
              data={{ ...profileData }}
              edit={false}
              submit={submitHandler}
              type="Edit"
            />
          )}

          {profileData && (
            <PatientProfileEmergencyInfo
              data={{ ...profileData }}
              edit={false}
              submit={submitHandler}
              type="Edit"
            />
          )}
        </div>
      </div>
    </div>
  );
}
